module.exports = __webpack_public_path__ + "d98c29ec42f3e3c9a5389d7ba25da388.svg";